import React from "react";
import UploadPropertiesTab from "./UploadPropertiesTab";
import UploadDatabaseTab from "./UploadDatabaseTab";
import UploadContactsTab from "./UploadContactsTab";
import UploadCompsTab from "./UploadCompsTab";
import GeocodePropertiesTab from "./GeocodePropertiesTab";

// Territory Upload is hidden for now. To bring it back, restore the TABS entry,
// the panel below, and the UploadTerritoryTab import.
var TABS = [
    { id: 'properties', label: 'Properties' },
    { id: 'database', label: 'Database' },
    { id: 'contacts', label: 'Contacts' },
    { id: 'comps', label: 'Comps' },
    { id: 'geocode', label: 'Geocode' },
];

export default class UploadCostarFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeTab: TABS[0].id };
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(tabId) {
        if (tabId !== this.state.activeTab) {
            this.setState({ activeTab: tabId });
        }
    }

    render() {
        var self = this;
        var activeTab = this.state.activeTab;
        // Keep both tab components mounted so their state (selected file, preview, etc.)
        // survives tab switches. Inactive tabs are hidden via CSS, not unmounted.
        return (
            <div className='upload-file-container'>
                <div className='upload-tabs' role='tablist'>
                    {TABS.map(function (tab) {
                        var isActive = tab.id === activeTab;
                        return (
                            <button
                                key={tab.id}
                                type='button'
                                role='tab'
                                className={'upload-tab' + (isActive ? ' upload-tab--active' : '')}
                                onClick={function () { self.handleTabClick(tab.id); }}
                            >
                                {tab.label}
                            </button>
                        );
                    })}
                </div>
                <div className='upload-tab-panel' hidden={activeTab !== 'properties'}>
                    <UploadPropertiesTab/>
                </div>
                <div className='upload-tab-panel' hidden={activeTab !== 'database'}>
                    <UploadDatabaseTab/>
                </div>
                <div className='upload-tab-panel' hidden={activeTab !== 'contacts'}>
                    <UploadContactsTab/>
                </div>
                <div className='upload-tab-panel' hidden={activeTab !== 'comps'}>
                    <UploadCompsTab/>
                </div>
                <div className='upload-tab-panel' hidden={activeTab !== 'geocode'}>
                    <GeocodePropertiesTab/>
                </div>
            </div>
        );
    }
}
